<template>
    <div>
        <button data-test="info-session-option" tabindex="0" type="button" aria-pressed="false" class="btn info-course-button text-start ps-5 p-3 mb-3" :class="[isActive ?  'selected' : '']">{{dayFormat}} at {{startTimeFormat}} - {{endTimeFormat}}</button>
    </div>
</template>

<script setup>
import { format } from 'date-fns';
import { parse } from 'date-fns';
import { computed, watch, ref, toRef } from "vue";

const props = defineProps({
    selected: String,
    startDate: String,
    startTime: String,
    endTime: String,
    infoSessionId: String
})
const selected = toRef(props, 'selected')
const isActive = ref(false)

let dayFormat = computed(() => {
    return format(new Date(props.startDate), 'EEEE do LLLL yyyy')
})
let startTimeFormat = computed(() => {
    const parsedTime = props.startTime ? parse(props.startTime, 'HH:mm', new Date()) : '';
    return parsedTime ? format(parsedTime, 'h:mm a') : 'TBC';
})
let endTimeFormat = computed(() => {
    const parsedTime = props.endTime ? parse(props.endTime, 'HH:mm', new Date()) : '';
    return parsedTime ? format(parsedTime, 'h:mm a') : 'TBC';
})

watch(selected, () => {
    isActive.value = selected.value === props.infoSessionId;
})
</script>

<style scoped>
@media (min-width: 768px) {
    .info-course-button {
        width: 38rem !important;
    }
}

.info-course-button {
    font-weight: 500;
    width:100%;
    box-shadow: 4px 5px 22px 7px rgba(158,158,158,0.21);
    text-decoration: none;
    color: #007ab3;
    background: white;
}
.info-course-button:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.selected {
    color:white;
    background: #007ab3;
}

</style>
